import React from 'react';
import { Icon } from '../Icon/Icon';

export function PatientTreatmentFooter() {
  return (
    <section className="tc-rise tc-d5 mb-2 mt-7 flex items-center gap-2.5 rounded-[var(--r-md)] border border-[var(--cream-2)] bg-[var(--cream-0)] px-[18px] py-3.5">
      <Icon kind="lock" size={13} style={{ color: 'var(--ink-3)' }} />
      <span className="text-[11.5px] leading-[1.5] text-[var(--ink-3)]">
        Fees and insurance come from ELVA&apos;s insurance check.
      </span>
    </section>
  );
}
